import React, { useEffect } from 'react';
import './StatusMessage.css';

const StatusMessage = ({ 
  message, 
  type = 'success', // 'success', 'error', 'warning', 'info'
  isVisible, 
  onClose, 
  duration = 5000,
  position = 'top-right' // 'top-right', 'top-center', 'bottom-right', 'bottom-center'
}) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '!';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '✓';
    }
  };

  return (
    <div className={`status-message status-message--${type} status-message--${position}`}>
      <div className="status-message__content">
        <span className="status-message__icon">{getIcon()}</span>
        <span className="status-message__text">{message}</span>
        <button 
          className="status-message__close" 
          onClick={onClose}
          aria-label="Close message"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default StatusMessage;
